import React from "react";
import Config from "../Common/Config/Config";

const Create: React.FC = () => {
    return (
        <Config reportConfig={null} />
    );
};
export default Create;
